var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',{staticStyle:{"height":"600px","padding":"20px"}},[_c('router-link',{staticClass:"app",attrs:{"to":"/signup/index"}},[_vm._v("预约报名")]),_c('div',{staticClass:"app",on:{"click":_vm.gotoSurvey}},[_vm._v("调查问卷")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }